export default __webpack_public_path__ + "static/media/headerlogo.9c665ee4.svg";